import React from 'react';
import { Link } from 'react-router-dom';

export default function InternalLinksSection({ links }) {
  if (!links || links.length === 0) return null;

  return (
    <section className="my-10 p-5 rounded-[6px] border border-[#DCE3EC] bg-white">
      <h3 className="text-xs font-bold uppercase tracking-wider text-[#5C6670] mb-3">
        Relaterede guider og artikler
      </h3>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-[15px]">
        {links.map((link, idx) => (
          <li key={idx}>
            <Link
              to={link.href}
              className="text-[#2A4DB0] hover:underline flex items-center gap-1.5"
            >
              <span>→</span>
              <span>{link.text}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
